import { Link } from 'react-router-dom'
import { ShieldAlert } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'

export function AccessDeniedPage() {
  return (
    <div className='flex min-h-screen items-center justify-center bg-muted/30 px-4'>
      <Card className='w-full max-w-sm text-center'>
        <CardHeader className='items-center'>
          <div className='mb-2 flex h-12 w-12 items-center justify-center rounded-xl bg-destructive/10'>
            <ShieldAlert className='h-6 w-6 text-destructive' />
          </div>
          <CardTitle className='text-xl'>You don&apos;t have access</CardTitle>
          <CardDescription>
            Your account has been disabled or doesn&apos;t have access to this application.
            Contact an administrator if you believe this is a mistake.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Link to='/login'>
            <Button className='w-full'>Back to sign in</Button>
          </Link>
        </CardContent>
      </Card>
    </div>
  )
}
